import {Overlay} from "ol";

export class HelpTooltip {
    /**
     * @param {EpMap}
     */
    epMap = null;

    /**
     * @type {Overlay}
     */
    tooltip = null;
    tooltipElement = null;

    message = null;

    constructor(epMap) {
        this.epMap = epMap;

        this.epMap.map.on('pointermove', (e) => {
            if (e.dragging) {
                return;
            }

            if (this.tooltip) {
                this.tooltipElement.innerHTML = this.message;
                this.tooltip.setPosition(e.coordinate);

                this.tooltipElement.classList.remove('hidden');
            }
        })

        this.epMap.map.getViewport().addEventListener('mouseout', () => {
            if (this.tooltipElement) {
                this.tooltipElement.classList.add('hidden');
            }
        });
    }

    set(message) {
        this.message = message;

        if (this.tooltip == null) {
            this.tooltipElement = document.createElement('div');
            this.tooltipElement.className = 'ol-tooltip hidden';
            this.tooltip = new Overlay({
                element: this.tooltipElement,
                offset: [15, 0],
                positioning: 'center-left',
            });
            this.epMap.map.addOverlay(this.tooltip);
        }
    }

    clear() {
        if (this.tooltip) {
            this.epMap.map.removeOverlay(this.tooltip);
            this.tooltip = null;
        }

        this.message = null;
    }
}